import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import CuestionarioVentViewer from './CuestionarioVentViewer';

export default function MainCuestionarioVent() {
  const { idCuestionario, paciente } = useParams();
  return (
    <DashboardLayout>
      <Container maxWidth="lg" sx={{ mt:4, mb:4 }}>
        <CuestionarioVentViewer idCuestionario={idCuestionario} paciente={paciente} />
      </Container>
    </DashboardLayout>
  );
}
